export enum UserType {
  PERSONAL = 'PERSONAL',
  MANAGED = 'MANAGED', // sales
}

export enum Role {
  USER = 'USER',
  MODERATOR = 'MODERATOR', // sales
  ADMIN = 'ADMIN',
  SUPER_USER = 'SUPER_USER',
}

export enum ESuperUserAccountType {
  CLIENT = 'CLIENT',
  EYEVIATION = 'EYEVIATION',
}

export enum ESalesAccountType {
  CLIENT = 'CLIENT',
  EYEVIATION = 'EYEVIATION',
}